function validateMeterChangeRow(row) {
  const issues = [];

  const tooLong = (field, value, max) => {
    if (value != null && String(value).length > max) {
      issues.push(`${field} must be at most ${max} characters`);
    }
  };

  // Alphanumeric fields: only letters, numbers, hyphens and underscores
  const invalidAlphaNumeric = (field, value) => {
    if (value && /[^A-Za-z0-9\-_]/.test(String(value))) {
      issues.push(`${field} must contain only letters, numbers, hyphens and underscores`);
    }
  };

  // Comments field: letters, numbers, hyphens, underscores, full stops and commas only
  const invalidComments = (field, value) => {
    if (value && /[^A-Za-z0-9\-_.,\s]/.test(String(value))) {
      issues.push(`${field} must contain only letters, numbers, hyphens, underscores, full stops and commas`);
    }
  };

  // Accepts dd/mm/yy, dd/mm/yyyy, ddmmyy, ddmmyyyy only
  const { parseUKDate } = require('./meterChange.helpers');
  const isValidDate = (v) => {
    if (v == null || v === '') return false;
    const d = parseUKDate(v);
    return !Number.isNaN(d.getTime());
  };

  // ReqType (varchar) - must be 'MC' or 'EM'
  if (!row.ReqType || String(row.ReqType).trim() === '') {
    issues.push('ReqType is required');
  } else {
    const rt = String(row.ReqType).trim().toUpperCase();
    if (rt !== 'MC' && rt !== 'EM') {
      issues.push("ReqType must be 'MC' or 'EM'");
    }
  }

  // Unit (int) - required, numeric integer
  if (row.Unit == null || String(row.Unit).trim() === '') {
    issues.push('Unit is required');
  } else if (!/^\d+$/.test(String(row.Unit))) {
    issues.push('Unit must be numeric');
  } else {
    // basic bounds check (fits in SQL int)
    const n = Number(row.Unit);
    if (!Number.isInteger(n) || n < -2147483648 || n > 2147483647) {
      issues.push('Unit must be a valid integer');
    }
  }

  // EVN (varchar(20)) - required, length
  if (!row.EVN || String(row.EVN).trim() === '') {
    issues.push('EVN is required');
  } else {
    tooLong('EVN', row.EVN, 20);
    invalidAlphaNumeric('EVN', row.EVN);
  }

  // OldMeter (varchar(30)) - required
  if (!row.OldMeter || String(row.OldMeter).trim() === '') {
    issues.push('OldMeter is required');
  } else {
    tooLong('OldMeter', row.OldMeter, 30);
    invalidAlphaNumeric('OldMeter', row.OldMeter);
  }

  // NewMeter (varchar(30)) - required (allow literal like 'END' per earlier notes)
  if (!row.NewMeter || String(row.NewMeter).trim() === '') {
    issues.push('NewMeter is required');
  } else {
    tooLong('NewMeter', row.NewMeter, 30);
    // allow "END" or alphanum, but still check invalid chars
    invalidAlphaNumeric('NewMeter', row.NewMeter);
  }

  // NewEFDT (date) - required and valid UK date
  if (!isValidDate(row.NewEFDT)) {
    issues.push('NewEFDT must be a valid date (dd/mm/yyyy or ddmmyyyy)');
  }

  // OldETDT (date) - required and valid UK date
  if (!isValidDate(row.OldETDT)) {
    issues.push('OldETDT must be a valid date (dd/mm/yyyy or ddmmyyyy)');
  }

  // If both datetimes valid, ensure OldETDT <= NewEFDT
  if (isValidDate(row.OldETDT) && isValidDate(row.NewEFDT)) {
    const oldDt = new Date(row.OldETDT);
    const newDt = new Date(row.NewEFDT);
    if (oldDt.getTime() > newDt.getTime()) {
      issues.push('OldETDT must be earlier than or equal to NewEFDT');
    }
  }

  // Comments (optional) - letters, numbers, hyphens, underscores, full stops and commas only
  if (row.Comments) {
    tooLong('Comments', row.Comments, 255);
    invalidComments('Comments', row.Comments);
  }

  // User - table has default '', not required by UI; if present ensure length
  if (row.User != null) {
    tooLong('User', row.User, 255);
  }

  return issues;
}

export default validateMeterChangeRow;
